
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getProductPluginList } from '@/api/app'
import edit from './components/edit.vue'
import fund from './components/fund.vue'
import axios from 'axios'

@Component({
  name: 'appSoftware',
  components: {
    edit,
    fund
  }
})
export default class extends Vue {
  private queryForm: any = {
    name: '',
    tag: ''
  }
  private allTotal = 0
  private total = 0
  private listLoading = false
  private allList: any[] = []
  private list: any[] = []
  private currencyList: any = []
  private tabName: string = 'basicInformation'
  private activeName: any = 'all'
  private infoName: any = '1'

  private waitInstallation: boolean = false
  private timer: any = null

  private async handleClick(item: any) {
    if (item.name !== 'all') {
      AppModule.SetCurrentCurrencyType(item.name)
      await this.changeTagQuery(item.name)
    } else {
      AppModule.SetCurrentCurrencyType('')
    }
  }

  // 全部等待安装软件loading
  private async init() {
    await this.hadleGetFilesListApi()
    for (let i = 0; i < this.allList.length; i++) {
      if (this.allList[i].installing === 1) {
        this.pollingSoftware(this.allList[i].id)
        this.timer = setInterval(() => {
          setTimeout(() => {
            this.pollingSoftware(this.allList[i].id)
          }, 0)
        }, 4500)
      }
    }
  }

  // 分类等待安装软件loading
  private async tabInit(row: any) {
    await this.changeTagQuery(row.currency)
    for (let i = 0; i < this.list.length; i++) {
      if (this.list[i].installing === 1) {
        this.pollingSoftware(this.list[i].id)
        this.timer = setInterval(() => {
          setTimeout(() => {
            this.pollingSoftware(this.list[i].id)
          }, 0)
        }, 4500)
      }
    }
  }

  // 轮询对应的软件
  private async pollingSoftware(id: any) {
    await axios({
      url: this.development
        ? 'https://dapi.zolopay.com/api/manage/open-product-plugin'
        : 'https://dapi.paypptp.com/api/manage/open-product-plugin',
      method: 'get',
      params: {
        id: id,
        corporation_id: AppModule.enterprise.corporation,
        enterprise_id: AppModule.enterprise.id,
        cloud_instance: AppModule.enterprise.cloud_instance
      }
    }).then((res: any) => {
      if (res.data) {
        for (let j = 0; j < res.data.results.length; j++) {
          if (res.data.results[j].installing === 0) {
            clearInterval(this.timer)
            clearTimeout(this.timer)
            this.timer = null //清空内存
            if (this.activeName === 'all') {
              this.hadleGetFilesListApi()
            } else {
              this.changeTagQuery(this.activeName)
            }
          }
        }
      }
    })
  }

  private query() {
    this.hadleGetFilesListApi()
  }

  // 切换tag查询
  private async changeTagQuery(valueNanme: any) {
    try {
      this.listLoading = true
      if (valueNanme === 'all') {
        valueNanme = ''
      }
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-product-plugin'
          : 'https://dapi.paypptp.com/api/manage/open-product-plugin',
        method: 'get',
        params: {
          tag: valueNanme,
          page_size: this.pagesize,
          page: this.currentPage,
          corporation_id: AppModule.enterprise.corporation,
          enterprise_id: AppModule.enterprise.id,
          cloud_instance: AppModule.enterprise.cloud_instance
        }
      }).then((res: any) => {
        if (res) {
          this.list = res.data.results
          this.total = res.data.count
          this.listLoading = false
        }
      })
    } catch (error) {
      if (error.response) {
        this.$message.error(error.response.data.message)
      }
      this.listLoading = false
    }
  }

  // 点击分类查询
  private dynamic: any = 1
  private async clickClassQuery(name: any, type: string, tag: number) {
    try {
      this.listLoading = true
      this.dynamic = tag
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-product-plugin'
          : 'https://dapi.paypptp.com/api/manage/open-product-plugin',
        method: 'get',
        params: {
          plugin_type: type,
          page_size: this.pagesize,
          page: this.currentPage,
          corporation_id: AppModule.enterprise.corporation,
          enterprise_id: AppModule.enterprise.id,
          cloud_instance: AppModule.enterprise.cloud_instance
        }
      }).then((res: any) => {
        if (res) {
          this.list = res.data.results
          this.total = res.data.count
          this.listLoading = false
        }
      })
    } catch (error) {
      if (error.response) {
        this.$message.error(error.response.data.message)
      }
      this.listLoading = false
    }
  }

  // 编辑应用
  private openEdit: boolean = false
  private appItem: any = null
  private openEditVisible(item: any) {
    this.appItem = item
    this.openEdit = true
  }
  private closeEdit() {
    this.openEdit = false
    this.hadleGetFilesListApi()
    this.infoName = '1'
  }

  // 标签分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }
  // 标签分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 获取全部应用列表
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-product-plugin'
          : 'https://dapi.paypptp.com/api/manage/open-product-plugin',
        method: 'get',
        params: {
          ...this.queryForm,
          page_size: this.pagesize,
          page: this.currentPage,
          corporation_id: AppModule.enterprise.corporation,
          enterprise_id: AppModule.enterprise.id,
          cloud_instance: AppModule.enterprise.cloud_instance
        }
      }).then((res: any) => {
        if (res) {
          this.allList = res.data.results
          this.total = res.data.count
          this.listLoading = false
        }
      })
    } catch (error) {
      if (error.response) {
        this.$message.error(error.response.data.message)
      }
      this.listLoading = false
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async allDownload(row) {
    try {
      this.listLoading = true
      this.flag = true
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-task'
          : 'https://dapi.paypptp.com/api/manage/open-task',
        method: 'post',
        data: {
          cloud_instance: AppModule.enterprise.cloud_instance,
          name: '安装软件',
          func: 'install_plugin',
          func_param: {
            plugin: row.id,
            corporation_id: AppModule.enterprise.corporation,
            enterprise_id: AppModule.enterprise.id,
            corporation_name: AppModule.enterprise.corporation_name,
            enterprise_name: AppModule.enterprise.name
          }
        }
      }).then((res: any) => {
        this.init()
        this.listLoading = false
        this.flagStr()
      })
    } catch (error) {
      if (error.response) {
        this.$message.error(error.response.data.message)
      }
      this.listLoading = false
      this.flagStr()
    }
  }
  private async download(row) {
    try {
      this.listLoading = true
      this.flag = true
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-task'
          : 'https://dapi.paypptp.com/api/manage/open-task',
        method: 'post',
        data: {
          cloud_instance: AppModule.enterprise.cloud_instance,
          name: '安装软件',
          func: 'install_plugin',
          func_param: {
            plugin: row.id,
            corporation_id: AppModule.enterprise.corporation,
            enterprise_id: AppModule.enterprise.id,
            corporation_name: AppModule.enterprise.corporation_name,
            enterprise_name: AppModule.enterprise.name
          }
        }
      }).then((res: any) => {
        this.listLoading = false
        this.tabInit(row)
        this.flagStr()
      })
    } catch (error) {
      if (error.response) {
        this.$message.error(error.response.data.message)
      }
      this.listLoading = false
      this.flagStr()
    }
  }

  private development: boolean = true
  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  

  mounted() {
    if (
      window.location.origin === 'https://manage.zolopay.com' ||
      window.location.origin === 'https://manage.lucky-money.in' ||
      window.location.hostname === 'localhost'
    ) {
      // 测试环境的处理逻辑
      this.development = true
    } else {
      // 正式环境的处理逻辑
      this.development = false
    }
    this.currencyList = AppModule.enterprise.available_currency
    this.dynamic = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.appSoftware`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.appSoftware`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
